(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mobile-category-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(e) {
  const toggle = e.target.closest('.mobile_category_toggle');
  if (!toggle) return;

  // Only toggle the direct parent .mobile_category_custom
  const parentCustom = toggle.parentElement;
  if (!parentCustom.classList.contains('mobile_category_custom')) return;

  // Toggle active class
  parentCustom.classList.toggle('active');

  // Update aria-expanded
  toggle.setAttribute('aria-expanded', parentCustom.classList.contains('active'));
});
  } catch(e) { console.error(e); }
})();

})();
